export default {
  props: {
    title: {
      type: String,
      default: undefined,
    },
    titleFontColor: {
      type: String,
      default: '#fff',
    },
    titleFontSize: {
      type: [Number, String],
      default: 24,
    },
    titleFontBold: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    titleStyle() {
      return {
        color: this.titleFontColor,
        fontSize: `${this.titleFontSize}px`,
        fontWeight: this.titleFontBold ? 700 : 400,
      };
    },
  },
};
